import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/manage-image`;

const list = (merchantId) => {
	return Client.get(`${baseUrl}/${merchantId}/list/giftCard/image`);
};

const remove = (merchantId, imageId) => {
	return Client.del(
		`${baseUrl}/${merchantId}/giftCard/image/remove/${imageId}`
	);
};

const sort = (merchantId, data) => {
	return Client.post(`${baseUrl}/${merchantId}/sort/giftCard`, data);
};

export default { list, remove, sort };
